import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    action: 'home'
  },
  mutations: {
    updateAction(state, payload) {
      state.action = payload;
    }
  },
  actions: {
    updateAction({ commit }, payload) {
      commit('updateAction', payload);
    }
  },
  getters: {
    mapAction(state) {
      return state.action;
    }
  }
})
